import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export function NotFound() {
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }} elevation={1}>
        <Typography variant="h1" component="h1" gutterBottom>
          Not found
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          We couldn&apos;t find what you were looking for.
        </Typography>
        <Box>
          <Button component={RouterLink} to="/" variant="contained">
            Home
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
